import type { ReactNode } from "react";

/**
 * Small header action button used on Step 4 review cards ("Test Email", "Edit").
 * Mirrors the prototype's `.review-action-btn` (Campaign-Builder-Master-Prototype.html,
 * CSS ~line 7194 onward).
 */
export interface ReviewActionButtonProps {
  label: string;
  icon: ReactNode;
  onClick: () => void;
}

export default function ReviewActionButton({ label, icon, onClick }: ReviewActionButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex cursor-pointer items-center gap-2 rounded-btn border border-smoke bg-white px-3.5 py-2 font-lato text-xs font-semibold text-rodeo-black transition-colors hover:border-dark-dust hover:bg-clear-dust hover:text-rodeo-black"
    >
      {icon}
      {label}
    </button>
  );
}
